const createLayerParsers = function ({
  $ = window.jQuery,
  _ = window._,
  momentRef = window.moment,
  windowRef = window,
  fnT = function (key) { return String(key || '') },
  fnStyle = function () { return {} },
  fnCordIsOnMap = function () { return false },
  fnLayerBuilder = function () {},
  fnIsValidLayerCord = function () { return true },
  aDMS_aDDT = (windowRef && windowRef.aDMS_aDDT),
  sDMS_aDDT = (windowRef && windowRef.sDMS_aDDT),
  sDMS_nDDT = (windowRef && windowRef.sDMS_nDDT),
  sDMSC_nDDT = (windowRef && windowRef.sDMSC_nDDT),
} = {}) {
  const NOTAM_COMPACT_POINT_REGEX = /^([0-8]\d[0-5]\d[0-5]\d[NSEW])([0-1]\d{2}[0-5]\d[0-5]\d[EWSN])$/

  const fnObjUniDiff = function (inputRaw, fnPickBy) {
    const input0 = Array.isArray(inputRaw) ? inputRaw : []
    if (input0.length === 0) return []
    let input = []
    if (typeof fnPickBy === 'function') {
      _.each(input0, function (val, key) {
        input[key] = _.pickBy(val, fnPickBy)
      })
    } else {
      input = input0
    }
    if (input.length === 1) return input[0]
    const commonProperties = _.reduce(input, function (result, obj) {
      return _.pickBy(result, function (value, key) { return _.isEqual(value, obj[key]) })
    }, input[0])
    const result = _.keys(commonProperties).length ? [commonProperties] : []
    _.forEach(input, function (obj) {
      const uniqueProperties = _.omit(obj, _.keys(commonProperties))
      if (_.keys(uniqueProperties).length) {
        result.push(uniqueProperties)
      }
    })
    return result
  }

  const fnJsonViewPhone = function ($cont) {
    $cont.find('span').each(function () {
      const alt = '@phone@'
      const $span = $(this)
      const text = $span.text()
      if (!text.includes(alt)) return this
      const phone = text.replace(/"/g, '').replace(alt, '')
      let phoneNum = phone.replace(/\D/g, '')
      if (phoneNum.indexOf('36') === 0) {
        phoneNum = '+' + phoneNum
      }
      if (text.includes(alt)) {
        $span.html('<a href="tel:' + phoneNum + '">' + phone + '</a>')
      }
    })
  }

  const fnDate = function (date) {
    return momentRef(date, 'YYMMDDHHmm').format('YYYY.MM.DD HH:mm')
  }

  const fnNormalizeNotamPointTokens = function (pointRaw) {
    if (Array.isArray(pointRaw) && pointRaw.length === 2) {
      const latToken = String(pointRaw[0] || '').trim()
      const lngToken = String(pointRaw[1] || '').trim()
      if (latToken && lngToken) return [latToken, lngToken]
      const packedMatch = latToken.match(NOTAM_COMPACT_POINT_REGEX)
      if (packedMatch && !lngToken) {
        return [packedMatch[1], packedMatch[2]]
      }
    }
    if (Array.isArray(pointRaw) && pointRaw.length === 1) {
      const packedToken = String(pointRaw[0] || '').trim()
      const packedMatch = packedToken.match(NOTAM_COMPACT_POINT_REGEX)
      if (packedMatch) {
        return [packedMatch[1], packedMatch[2]]
      }
    }
    if (typeof pointRaw === 'string') {
      const packedToken = pointRaw.trim()
      const packedMatch = packedToken.match(NOTAM_COMPACT_POINT_REGEX)
      if (packedMatch) {
        return [packedMatch[1], packedMatch[2]]
      }
    }
    return Array.isArray(pointRaw) ? pointRaw : null
  }

  const fnNormalizeNotamAreaKey = function (value) {
    return String(value || '')
      .trim()
      .replace(/[,:.\s]+$/g, '')
      .replace(/\//g, ' ')
      .replace(/\s+/g, ' ')
      .toUpperCase()
  }

  const fnCloneNotamDraw = function (drawRaw) {
    const draw = (drawRaw && typeof drawRaw === 'object') ? drawRaw : {}
    const cloned = Object.assign({}, draw)
    if (Array.isArray(draw.point)) cloned.point = draw.point.slice()
    if (Array.isArray(draw.points)) cloned.points = draw.points.slice()
    if (Array.isArray(draw.type)) cloned.type = draw.type.slice()
    return cloned
  }

  const fnResolveNotamTypeHints = function (row) {
    const body = row && row.body && typeof row.body === 'object' ? row.body : {}
    const text = String(body.E || '').toUpperCase()
    const hints = []
    const pushHint = function (value) {
      const nextValue = String(value || '').trim()
      if (!nextValue || hints.includes(nextValue)) return
      hints.push(nextValue)
    }
    if (text.includes('AREA WITH SENSITIVE FAUNA')) pushHint('protected')
    if (text.includes('RESTRICTED AREA')) pushHint('restricted')
    if (text.includes('TEMPORARY RESERVED AIRSPACE')) pushHint('restricted')
    if (text.includes('AEROBATICS AREA')) pushHint('restricted')
    if (text.includes('DANGER AREA')) pushHint('danger')
    if (text.includes('TEMPORARY RESTRICTED')) pushHint('temporary-restricted')
    if (text.includes('MILITARY')) pushHint('military')
    if (text.includes('UNMANNED AIRCRAFT')) pushHint('uas')
    if (text.includes('GLIDER FLYING AND AEROBATICS')) pushHint('glider')
    return hints
  }

  const fnMergeNotamTypes = function (draw, row) {
    const merged = []
    const appendUnique = function (value) {
      const nextValue = String(value || '').trim()
      if (!nextValue || merged.includes(nextValue)) return
      merged.push(nextValue)
    }
    ;(Array.isArray(draw && draw.type) ? draw.type : []).forEach(appendUnique)
    fnResolveNotamTypeHints(row).forEach(appendUnique)
    return merged
  }

  const fnResolveNotamAirspaceClassId = function (draw, row) {
    const drawTypes = fnMergeNotamTypes(draw, row)
    if (drawTypes.includes('protected')) return 100
    if (drawTypes.includes('restricted') || drawTypes.includes('temporary-restricted')) return 101
    if (drawTypes.includes('danger')) return 11
    return 12
  }

  const fnFindRestrictedReferenceDraw = function (res, areaRaw) {
    const restrictedData = res &&
      res['restricted__ais.hungarocontrol.hu'] &&
      res['restricted__ais.hungarocontrol.hu'].data &&
      typeof res['restricted__ais.hungarocontrol.hu'].data === 'object'
      ? res['restricted__ais.hungarocontrol.hu'].data
      : null
    if (!restrictedData) return null
    const normalizedAreaKey = fnNormalizeNotamAreaKey(areaRaw)
    if (!normalizedAreaKey) return null
    const directMatch = restrictedData[areaRaw] || restrictedData[normalizedAreaKey] || null
    if (directMatch) return fnCloneNotamDraw(directMatch)
    const restrictedKeys = Object.keys(restrictedData)
    for (let i = 0; i < restrictedKeys.length; i++) {
      const restrictedKey = restrictedKeys[i]
      if (fnNormalizeNotamAreaKey(restrictedKey) === normalizedAreaKey) {
        return fnCloneNotamDraw(restrictedData[restrictedKey])
      }
    }
    return null
  }

  const layerNotams = function (res) {
    const source = 'notam__flightplan.romatsa.ro'
    if (!(res[source] && res[source].data)) {
      console.error(fnT('log.generic_error_prefix'), source)
      return false
    }
    $.each(res[source].data, function (_key, row) {
      row.source = source
      const rob = row.body
      const geometryMeta = rob && rob.inf && rob.inf.geometry && typeof rob.inf.geometry === 'object'
        ? rob.inf.geometry
        : null
      if (geometryMeta && geometryMeta.status === 'suppressed') {
        return this
      }
      const referenceDraw = rob && rob.inf && rob.inf.area
        ? fnFindRestrictedReferenceDraw(res, rob.inf.area)
        : null
      let draw = referenceDraw || fnCloneNotamDraw(rob.inf)
      if (typeof draw === 'undefined') {
        console.warn(fnT('log.undefined_area'), row)
        return this
      } else if (referenceDraw) {
        row.body.inf.areaData = fnCloneNotamDraw(referenceDraw)
      }
      draw.type = fnMergeNotamTypes(draw, row)
      row.body.inf.type = draw.type.slice()
      row.airspace_class_id = fnResolveNotamAirspaceClassId(draw, row)
      row.style = fnStyle(draw.type, row)
      row.label = row.notam
      const drawKeys = Object.keys(draw)
      if (drawKeys.includes('point') && draw.point.length) {
        const pointTokens = fnNormalizeNotamPointTokens(draw.point)
        if (Array.isArray(pointTokens) && pointTokens.length) {
          draw.point = pointTokens
        }
        row.cord = aDMS_aDDT(draw.point)
        let rad
        if (draw.radius && typeof draw.radius === 'string') {
          rad = (draw.radius).replace(/ /g, '')
          if (rad.includes('KM')) {
            rad = (draw.radius).replace('KM', '') * 1000
          } else if (rad.includes('M')) {
            rad = (draw.radius).replace('M', '') * 1
          }
        }
        if (row.cord && rad) {
          row.shape = 'circle'
          row.style.radius = rad
        }
      }
      if (drawKeys.includes('points') && draw.points.length) {
        row.shape = 'polygon'
        row.cord = []
        if (typeof draw.points[0] === 'string') {
          $.each(draw.points, function (_k2, pointStr) {
            row.cord.push(sDMS_aDDT(pointStr))
          })
        } else {
          $.each(draw.points, function (_k3, aDMS) {
            row.cord.push(aDMS_aDDT(aDMS))
          })
        }
      }
      if (typeof row.shape === 'undefined') {
        console.warn(fnT('log.row_shape_undefined'), row)
        return this
      }
      if (!fnIsValidLayerCord(row.shape, row.cord)) {
        console.warn(fnT('log.skip_notam_invalid_coords'), row.notam, row.cord)
        return this
      }
      if (fnCordIsOnMap(row)) return this
      fnLayerBuilder(row, function (modal) {
        const $cont = $(modal).find('.swal2-html-container').addClass('text-start')
        const rows = fnCordIsOnMap(row, false).rows
        console.log(rows)
        const rowsToDiff = []
        $.each(rows, function (_kr, rowInner) {
          const rowForm = {}
          const rowPick = _.pickBy(rowInner, function (val, key) {
            if (val === null) return false
            if (val === undefined || (typeof val === 'object' && val.length === 0) || val === '') return false
            if (key === 'body' && val.inf && val.inf.phone) {
              const phones = []
              $.each(val.inf.phone, function (kp, vp) {
                phones[kp] = '@phone@' + vp
              })
              rowForm.phone = phones.join(', ')
              return false
            }
            if (['bounds', 'cord', 'style', 'id', 'body', 'notam', 'location', 'airspace_class_id'].includes(key)) return false
            if (['floor', 'ceil', 'usages'].includes(key)) return false
            return true
          })
          if (rowInner.body) {
            rowForm.notam = rowInner.notam + ' (' + rowInner.location + ')'
            rowForm.date = fnDate(rowInner.body.inf.date.from) + ' - ' + fnDate(rowInner.body.inf.date.to)
            rowForm.height = rowInner.body.inf.height.from.join(' ') + ' - ' + rowInner.body.inf.height.to.join(' ')
            if (rowInner.body.inf.pointsName) rowForm.name = rowInner.body.inf.pointsName
            if (rowInner.body.inf.type) rowForm.type = (rowInner.body.inf.type).join(', ')
          }
          if (rowInner.floor) rowForm.floor = rowInner.floor.text
          if (rowInner.ceil) rowForm.ceil = rowInner.ceil.text
          const rowMerge = _.merge(rowPick, rowForm)
          rowsToDiff.push(rowMerge)
        })
        const diff = fnObjUniDiff(rowsToDiff, function (val, key) {
          if (val === null) return false
          if (val === undefined || (typeof val === 'object' && val.length === 0) || val === '') return false
          if (['cord', 'style', 'shape', 'label'].includes(key)) return false
          return true
        })
        $cont.JSONView(_.reverse(diff), { collapsed: false })
        fnJsonViewPhone($cont)
      })
    })
  }

  const layerAirSpaces = function (res) {
    const source = 'airspaces__mer.re'
    $.each(res[source].data, function (_key, row) {
      row.source = source
      if (!row.notams === null) return this
      if (row.airspace_class_id === 12) return this
      row.style = {
        radius: 0
      }
      row.cord = []
      row.label = row.name
      if (row.shape === 'circle') {
        row.style = fnStyle(['circle', 'airspace', row.airspace_class_id], row)
        $.each(row.bounds, function (_i, bon) {
          if (typeof bon === 'object') {
            row.cord = bon
          } else {
            row.style.radius = bon
          }
        })
      }
      if (row.shape === 'polygon') {
        row.style = fnStyle(['polygon', 'airspace', row.airspace_class_id], row)
        row.cord = row.bounds
      }
      if (fnCordIsOnMap(row)) return this
      fnLayerBuilder(row, function (modal) {
        const $cont = $(modal).find('.swal2-html-container').addClass('text-start')
        const rowForm = {}
        console.log(row)
        const rowPick = _.pickBy(row, function (val, key) {
          if (val === null) return false
          if (val === undefined || (typeof val === 'object' && val.length === 0) || val === '') return false
          if (['bounds', 'cord', 'style', 'id'].includes(key)) return false
          if (key === 'contact') {
            const contacts = val.split(', ')
            rowForm.contacts = {}
            $.each(contacts, function (_kct, vct) {
              if (vct.includes('MHz')) {
                rowForm.contacts.radio = vct
              } else {
                rowForm.contacts.phone = '@phone@' + vct
              }
            })
            return false
          }
          if (key === 'airspace_class_id') {
            rowForm.airspace = {
              short: windowRef.airSpaceTypes[val].short,
              en: windowRef.airSpaceTypes[val].en,
              hu: windowRef.airSpaceTypes[val].hu
            }
            return false
          }
          return true
        })
        const rowMerge = _.merge(rowForm, rowPick)
        $cont.JSONView(rowMerge, { collapsed: false })
        fnJsonViewPhone($cont)
      })
    })
  }

  const layerAirPorts = function (res) {
    const source = 'airports__ourairports.com'
    $.each(res[source].data, function (_key, row) {
      row.source = source
      row.airspace_class_id = 200
      row.shape = 'circle'
      row.label = row.name
      row.style = fnStyle(['circle', 'airport', row.class], row)
      row.cord = [sDMS_nDDT(row.dms_lat), sDMS_nDDT(row.dms_lng)]
      if (fnCordIsOnMap(row)) return this
      fnLayerBuilder(row, function (modal) {
        const $cont = $(modal).find('.swal2-html-container').addClass('text-start')
        const rowForm = {}
        console.log(row)
        const rowPick = _.pickBy(row, function (val, key) {
          if (val === null) return false
          if (val === undefined || (typeof val === 'object' && val.length === 0) || val === '') return false
          if (['bounds', 'cord', 'style', 'id'].includes(key)) return false
          if (key === 'phone') {
            rowForm.phone = row.phone.split(', ')
            $.each(rowForm.phone, function (k, _v) {
              rowForm.phone[k] = '@phone@+36 ' + rowForm.phone[k]
            })
            return false
          }
          return true
        })
        const rowMerge = _.merge(rowForm, rowPick)
        $cont.JSONView(rowMerge, { collapsed: false })
        fnJsonViewPhone($cont)
      })
    })
  }

  const collectVersions = function (res) {
    const nextLayerVersions = {}
    $.each(res, function (source, things) {
      $.each(things, function (key, val) {
        if (['versions'].includes(key)) {
          if (!Object.keys(nextLayerVersions).includes(source)) {
            nextLayerVersions[source] = {}
          }
          nextLayerVersions[source][key] = val
        }
      })
    })
    console.log(nextLayerVersions)
    return nextLayerVersions
  }

  const layerNature = function (res) {
    const source = 'nature__termeszetvedelem.hu'
    const resNature = []
    $.each(res[source].data, function (_key, row) {
      row.source = source
      const rowForm = {}
      const rowPick = _.pickBy(row, function (val, key) {
        if (val === null) return false
        if (val === undefined || (typeof val === 'object' && val.length === 0) || val === '') return false
        if (['date_from_month', 'date_from_day', 'date_to_month', 'date_to_day', 'floor_agl_m', 'ceil_agl_m'].includes(key)) return false
        return true
      })
      const dates = [
        momentRef(row.date_from_month, 'M').format('MMMM') + ' ' + row.date_from_day + '.',
        momentRef(row.date_to_month, 'M').format('MMMM') + ' ' + row.date_to_day + '.'
      ]
      rowForm.date_range = dates.join(' - ')
      rowForm.height_m = [row.floor_agl_m, row.ceil_agl_m].join(' - ')
      const rowMerge = _.merge(rowPick, rowForm)
      resNature.push(rowMerge)
    })
    $.each(resNature, function (_key2, row) {
      const fnNatureDidOpen = function (modal) {
        const $cont = $(modal).find('.swal2-html-container').addClass('text-start')
        const rows = fnCordIsOnMap(row, false).rows
        const diff = fnObjUniDiff(rows, function (val, key) {
          if (val === null) return false
          if (val === undefined || (typeof val === 'object' && val.length === 0) || val === '') return false
          if (['cord', 'style', 'shape', 'label', 'points_dmsc', 'circle_radius_m', 'circle_center_dmsc'].includes(key)) return false
          return true
        })
        $cont.JSONView(diff, { collapsed: false })
      }
      row.airspace_class_id = 10
      row.label = row.name
      if (row.points_dmsc) {
        row.shape = 'polygon'
        const points = String(row.points_dmsc).split(' ')
        row.cord = []
        for (let i = 0; i < points.length; i = i + 2) {
          row.cord.push([sDMSC_nDDT(points[i]), sDMSC_nDDT(points[i + 1])])
        }
        row.style = fnStyle([row.shape, 'nature'], row)
        if (!fnCordIsOnMap(row)) {
          fnLayerBuilder(row, fnNatureDidOpen)
        }
      }
      if (row.circle_radius_m && row.circle_center_dmsc) {
        ;(function (rrr) {
          rrr.shape = 'circle'
          rrr.cord = aDMS_aDDT(String(rrr.circle_center_dmsc).split(' '))
          rrr.style = fnStyle([rrr.shape, 'nature'], rrr)
          rrr.style.radius = rrr.circle_radius_m * 1
          if (!fnCordIsOnMap(rrr)) {
            fnLayerBuilder(rrr, fnNatureDidOpen)
          }
        })($.extend({}, row))
      }
    })
  }

  const layerUser = function (res) {
    const source = 'user_layers'
    $.each(res[source].data, function (_key, row) {
      row.source = source
      const fnNatureDidOpen = function (modal) {
        const $cont = $(modal).find('.swal2-html-container').addClass('text-start')
        const rows = fnCordIsOnMap(row, false).rows
        const diff = fnObjUniDiff(rows, function (val, key) {
          if (val === null) return false
          if (val === undefined || (typeof val === 'object' && val.length === 0) || val === '') return false
          if (['user_id', 'cord'].includes(key)) return false
          return true
        })
        $cont.JSONView(diff, { collapsed: false })
      }
      row.airspace_class_id = 300
      row.label = row.title
      if (row.shape === 'polygon' && row.cord_dmsc) {
        const points = String(row.cord_dmsc).replace(/\s+/g, ' ').trim().split(' ')
        row.cord = []
        for (let i = 0; i < points.length; i = i + 2) {
          row.cord.push([sDMSC_nDDT(points[i]), sDMSC_nDDT(points[i + 1])])
        }
        row.style = fnStyle([row.shape, 'user_layer'], row)
        if (!fnCordIsOnMap(row)) {
          fnLayerBuilder(row, fnNatureDidOpen)
        }
      }
    })
  }

  return {
    layerNotams: layerNotams,
    layerAirSpaces: layerAirSpaces,
    layerAirPorts: layerAirPorts,
    layerNature: layerNature,
    layerUser: layerUser,
    collectVersions: collectVersions
  }
}

export {
  createLayerParsers
}
